module.exports = __webpack_public_path__ + "static/CalibreWeb-Bold-6fbac63c716d3e11479edeaecabaef5f.eot";